import { preload } from "../include/module";
import { anchorLink } from "../include/module";
import { fadeItem } from "../include/module";
import { mobileMenu } from "../include/module";
import { scrollStar } from "../include/module";
import { scrollAnimation } from "../include/module";
import { movieSwiper } from "../include/module";
import { showMovie } from "../include/module";
import { bnr_modal } from "../include/module";

(() => {

  preload();
  anchorLink();
  fadeItem();
  mobileMenu();
  scrollStar();
  movieSwiper();
  showMovie();
  bnr_modal();

})();

$(window).on('load', function(){
  setTimeout(function () {
    scrollAnimation();
  }, 100);
});
$(window).on('scroll', function(){
  scrollAnimation();
});



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js